var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-justify-content-center"},[_c('b-button',{style:(_vm.style),attrs:{"type":"is-primary","icon-left":"users","size":_vm.isMobile ? '' : 'is-medium',"rounded":"","outlined":""},on:{"click":_vm.clicked}},[_vm._v(_vm._s(_vm.$t("quickCall")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }